import * as THREE from 'three';

export const detailNodeGeometry = new THREE.SphereGeometry(4, 6, 6);
export const defaultNodeGeometry = new THREE.SphereGeometry(4, 24, 24);
export const detailNodeMaterial = new THREE.MeshStandardMaterial({
    color: '#000000',
    transparent: true,
    opacity: 0,
});
